export function hexToRgba(hex, alpha) {
  let r = 0
  let g = 0
  let b = 0
  if (hex && hex.length > 5) {
    // Удаляем "#" если оно есть
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16)
      g = parseInt(hex[2] + hex[2], 16)
      b = parseInt(hex[3] + hex[3], 16)
    } else if (hex.length === 7) {
      r = parseInt(hex[1] + hex[2], 16)
      g = parseInt(hex[3] + hex[4], 16)
      b = parseInt(hex[5] + hex[6], 16)
    }
    if (alpha) {
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    } else {
      return `rgb(${r}, ${g}, ${b})`
    }
  } else {
    return `#FFD832`
  }
}
